// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#__nuxt .global-wrapper.preview-mode .contact-widget__sticky{top:225px}", ""]);
// Exports
module.exports = exports;
